import Vue, { CreateElement, RenderContext, VNode } from "vue";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
interface Props {
  requiredAuthorities: string[];
  tag: string;
}

export default Vue.extend({
  functional: true,
  name: "CheckAuthorities",
  props: {
    requiredAuthorities: { type: Array, required: true },
    tag: { type: String, default: "div" },
  },
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    const currentAuthorities = ctx.parent.$store.state.authorities || [];
    const allowRender = checkAuthorities(currentAuthorities, ctx.props.requiredAuthorities);
    if (!allowRender) return h();
    const component = ctx.scopedSlots.default && ctx.scopedSlots.default({});
    if (component && component.length === 1) return component[0];
    return h(ctx.props.tag, {}, component);
  },
});
